var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_257_18415",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_257_18415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16047 10.4001C7.16047 9.5901 7.23297 9.0076 7.37797 8.6526C7.52297 8.2976 7.83047 7.9101 8.30047 7.4901C8.71047 7.1301 9.02297 6.8176 9.23797 6.5526C9.45297 6.2876 9.56047 5.9851 9.56047 5.6451C9.56047 5.2351 9.42297 4.8951 9.14797 4.6251C8.87297 4.3551 8.49047 4.2201 8.00047 4.2201C7.49047 4.2201 7.10297 4.3751 6.83797 4.6851C6.57297 4.9951 6.38547 5.3101 6.27547 5.6301L4.73047 4.9701C4.94047 4.3301 5.32547 3.7751 5.88547 3.3051C6.44547 2.8351 7.15047 2.6001 8.00047 2.6001C9.05047 2.6001 9.85797 2.8926 10.423 3.4776C10.988 4.0626 11.2705 4.7651 11.2705 5.5851C11.2705 6.0851 11.163 6.5126 10.948 6.8676C10.733 7.2226 10.3955 7.6251 9.93547 8.0751C9.44547 8.5451 9.14797 8.9026 9.04297 9.1476C8.93797 9.3926 8.88547 9.8101 8.88547 10.4001H7.16047ZM8.00047 14.0001C7.67047 14.0001 7.38797 13.8826 7.15297 13.6476C6.91797 13.4126 6.80047 13.1301 6.80047 12.8001C6.80047 12.4701 6.91797 12.1876 7.15297 11.9526C7.38797 11.7176 7.67047 11.6001 8.00047 11.6001C8.33047 11.6001 8.61297 11.7176 8.84797 11.9526C9.08297 12.1876 9.20047 12.4701 9.20047 12.8001C9.20047 13.1301 9.08297 13.4126 8.84797 13.6476C8.61297 13.8826 8.33047 14.0001 8.00047 14.0001Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.02b46e56f4c572548285e55430f2fa70.svg";
export { ForwardRef as ReactComponent };